import React from 'react';

import { useConfigs } from 'modules/configs';
import { useSiteNavigation } from 'pages/Landings/hooks/use-site-navigation';

import Item from './components/Item';
import Section from './components/Section';
import useStyles from './styles';

interface Props {
    className?: string;
}

const SiteNavigation: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const navigation = useSiteNavigation();
    const { entrypoint } = useConfigs();

    return (
        <div className={cx(classes.root, className)}>
            <Section title="Products">
                <Item title="Vulnerability Intelligence" {...navigation.products.intelligence} />
                <Item title="Assessment" {...navigation.products.assessment} />
                <Item title="Datasets" {...navigation.products.datasets} />
                <Item title="Alert" {...navigation.products.alerts} />
                <Item title="Exploits" {...navigation.products.exploits} />
                <Item title="MCP" {...navigation.products.mcp} />
            </Section>
            {entrypoint === 'main' ? (
                <Section title="Solutions">
                    <Item title="Security Automation SDK" {...navigation.solutions.securityAutomationSdk} />
                    <Item title="Data Feeds" {...navigation.solutions.dataFeeds} />
                    <Item title="MCP for AI Agents" {...navigation.solutions.mcpForAiAgents} />
                    <Item title="Exploits & KEV" {...navigation.solutions.exploitsAndKev} />
                    <Item title="White Label" {...navigation.solutions.whiteLabel} />
                </Section>
            ) : null}
            <Section title="Resources">
                <Item title="Developer SDK" {...navigation.resources.developerSdk} />
                <Item title="API Reference" {...navigation.resources.apiReference} />
                <Item title="Security Services" {...navigation.resources.securityServices} />
                <Item title="OpenSource & Tools" {...navigation.resources.ossAndTools} />
                <Item title="Change Log" {...navigation.resources.changelog} />
                <Item title="Support" {...navigation.resources.support} />
            </Section>
            <Section title="Company">
                <Item title="Pricing" {...navigation.company.pricing} />
                <Item title="Blog" {...navigation.company.blog} />
                <Item title="Contacts" {...navigation.company.contacts} />
                <Item title="EULA" {...navigation.company.eula} />
                <Item title="About" {...navigation.company.about} />
            </Section>
        </div>
    );
};

export default SiteNavigation;
